//Loads only those fees for the current logged in portal user
define(function() {
	var Backbone = require('backbone');
	const IpsModelCollection = require('civicsBase/ipsModelCollection');
	const urlBuilder = require('civicsUtils/buildUrlParameters');

	return IpsModelCollection.extend({
		unpaidOnly:false,
		urlRoot: '/delegate/civics-api/api/cdr/common/applications/{0}/fees', //{0} - commonID
		url:function(){
			var ret = this.urlRoot;

			if (this.commonID) {
				ret = this.urlRoot.format(this.commonID);
			}

      if (this.urlParameters) {
        ret += urlBuilder.buildUrlParameters(this.urlParameters)
      } else {

        var parameters = {};

        if (this.unpaidOnly) {
          parameters.filter = {property:'status',value:'U,I',operator:'In'};
        } else if (this.charges) {
          parameters.filter = {property: 'id',value: this.charges,operator:'In'};
        }

        parameters.page = {max:0, start: 1};
				parameters.orderBy = {property:'portalDescription',direction:'Asc'};

        ret += urlBuilder.buildUrlParameters(parameters)
      }

			if (this.getStatus === true) {
				if (ret.indexOf('?') >= 0) {
					ret += '&getStatus=true';
				} else {
					ret += '?getStatus=true';
				}
			}

			return ret;
		},
		parse: function(response) {
			this.responseStatus = response.responseStatus;

			$.each(response.data, (index, item) => {
					let instrumentPortalDesc = item.application.applicationType.portalDescription;
					item.application.applicationType.portalDescription = (instrumentPortalDesc) ? instrumentPortalDesc : item.application.applicationType.description;

					
			});

			return response.data;
		},
	});
});
